package cc.bluepeak.clubmanager.site.pages

import androidx.compose.runtime.Composable
import cc.bluepeak.clubmanager.site.Res
import cc.bluepeak.clubmanager.site.components.layouts.PageLayoutData
import cc.bluepeak.clubmanager.site.components.widgets.Checkmark
import cc.bluepeak.clubmanager.site.components.widgets.FieldTag
import cc.bluepeak.clubmanager.site.components.widgets.LineTag
import cc.bluepeak.clubmanager.site.components.widgets.LiveDemo
import cc.bluepeak.clubmanager.site.styles.ButtonLinkVariant
import cc.bluepeak.clubmanager.site.styles.PaddedCardStyle
import cc.bluepeak.clubmanager.site.styles.SecondaryParagraph
import cc.bluepeak.clubmanager.site.styles.Theme
import com.varabyte.kobweb.compose.css.BackgroundPosition
import com.varabyte.kobweb.compose.css.BackgroundSize
import com.varabyte.kobweb.compose.css.CSSPosition
import com.varabyte.kobweb.compose.css.JustifySelf
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.functions.url
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.background
import com.varabyte.kobweb.compose.ui.modifiers.backgroundImage
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.justifySelf
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxHeight
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.add
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.icons.lucide.LucideBanknoteCheck
import com.varabyte.kobweb.silk.components.icons.lucide.LucidePrinter
import com.varabyte.kobweb.silk.components.icons.lucide.LucideReceiptText
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.em
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text


@InitRoute
fun initInvoicing(ctx: InitRouteContext) {
    ctx.data.add(PageLayoutData(Res.string.invoicing_tag, Res.string.invoicing_title))
}

@Page
@Layout(".components.layouts.PageLayout")
@Composable
fun Invoicing() {
    Column(Modifier.fillMaxWidth(), verticalArrangement = Arrangement.spacedBy(2.cssRem)) {
        Column(PaddedCardStyle.toModifier().fillMaxWidth(), horizontalAlignment = Alignment.CenterHorizontally) {
            SimpleGrid(numColumns(1, md = 2), Modifier.gap(1.cssRem).fillMaxWidth()) {
                Column {
                    FieldTag(Res.string.invoicing_tag)
                    H1 {
                        Text(Res.string.invoicing_title)
                    }
                    P(
                        SecondaryParagraph.toModifier().margin(top = 1.cssRem, bottom = 2.cssRem)
                            .maxWidth(500.px).toAttrs()
                    ) {
                        Text(Res.string.invoicing_desc)
                    }
                    Column(verticalArrangement = Arrangement.spacedBy(.5.cssRem)) {
                        Checkmark(Res.string.invoicing_check_invoice)
                        Checkmark(Res.string.invoicing_check_fees)
                        Checkmark(Res.string.invoicing_check_payouts)
                        Checkmark(Res.string.invoicing_check_payments)
                    }
                }
                Image(
                    Res.image.demoInvoice, Modifier.borderRadius(Theme.shapes.medium)
                        .maxHeight(400.px)
                        .objectFit(ObjectFit.Contain)
                        .boxShadow(0.px, 0.px, 15.px, 0.px, Color.argb(70, 0, 0, 0))
                        .justifySelf(JustifySelf.Center)
                )
            }

        }
        LiveDemo("invoices", Res.string.invoicing_demo_cta, Res.string.invoicing_demo_hint)
        Column(PaddedCardStyle.toModifier().fillMaxWidth(), verticalArrangement = Arrangement.spacedBy(4.cssRem)) {
            SimpleGrid(numColumns(1, md = 2), Modifier.gap(1.cssRem).fillMaxWidth()) {
                Column {
                    FieldTag(Res.string.invoicing_invoices_tag)
                    H1 {
                        Text(Res.string.invoicing_invoices_title)
                    }
                    P(
                        SecondaryParagraph.toModifier().margin(top = 1.cssRem, bottom = 2.cssRem)
                            .maxWidth(500.px).toAttrs()
                    ) {
                        Text(Res.string.invoicing_invoices_desc)
                    }
                    Column(verticalArrangement = Arrangement.spacedBy(.5.cssRem)) {
                        Row(
                            verticalAlignment = Alignment.CenterVertically,
                            horizontalArrangement = Arrangement.spacedBy(.5.cssRem)
                        ) {
                            LucideReceiptText(color = Theme.primary, size = 1.5.em)
                            SpanText(Res.string.invoicing_invoices_check_professional)
                        }
                        Row(
                            verticalAlignment = Alignment.CenterVertically,
                            horizontalArrangement = Arrangement.spacedBy(.5.cssRem)
                        ) {
                            LucidePrinter(color = Theme.primary, size = 1.5.em)
                            SpanText(Res.string.invoicing_invoices_check_pdf)
                        }
                        Row(
                            verticalAlignment = Alignment.CenterVertically,
                            horizontalArrangement = Arrangement.spacedBy(.5.cssRem)
                        ) {
                            LucideBanknoteCheck(color = Theme.primary, size = 1.5.em)
                            SpanText(Res.string.invoicing_invoices_check_status)
                        }
                    }

                }
                Image(
                    Res.image.invoice_icon, Modifier.displayIfAtLeast(Breakpoint.MD)
                        .fillMaxWidth()
                        .maxHeight(280.px)
                        .objectFit(ObjectFit.Contain)
                )
            }
            SimpleGrid(numColumns(1, md = 2), Modifier.gap(1.cssRem).fillMaxWidth()) {
                Image(
                    Res.image.coins_icon, Modifier.displayIfAtLeast(Breakpoint.MD)
                        .fillMaxWidth()
                        .maxHeight(280.px)
                        .objectFit(ObjectFit.Contain)
                )

                Column {
                    FieldTag(Res.string.invoicing_fees_tag)
                    H1 {
                        Text(Res.string.invoicing_fees_title)
                    }
                    P(
                        SecondaryParagraph.toModifier().margin(top = 1.cssRem, bottom = 2.cssRem)
                            .maxWidth(500.px).toAttrs()
                    ) {
                        Text(Res.string.invoicing_fees_desc)
                    }
                    Link(Res.link.calendar, Res.string.invoicing_fees_cta, variant = ButtonLinkVariant)
                }
            }
        }
        SimpleGrid(
            numColumns(1, 2), PaddedCardStyle.toModifier().fillMaxWidth()
                .gap(1.cssRem)
                .backgroundImage(url("""/${Res.string.locale}/${Res.image.fabric1}"""))
                .background {
                    size(BackgroundSize.Cover)
                    position(BackgroundPosition.of(CSSPosition.Center))
                }) {
            Column {
                LineTag(Res.string.invoicing_cta_tag, Modifier.color(Theme.white))
                H1(Modifier.color(Theme.white).toAttrs()) {
                    Text(Res.string.invoicing_cta_title)
                }
            }
            Column(PaddedCardStyle.toModifier()) {
                P(Modifier.margin(bottom = 1.cssRem).toAttrs()) {
                    Text(Res.string.invoicing_cta_desc)
                }
                Link(Res.link.register, Res.string.invoicing_cta_cta, variant = ButtonLinkVariant)
            }
        }

    }
}